import { useIntl } from 'react-intl';
import { useState } from 'react';
import { Row, Col } from 'reactstrap';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import useAuth from 'src/hooks/useAuth';
import Edit from './edit';
import SearchSchema from './SearchSchema';
import Search from './search';
import { capitalizeFirstLetter } from 'src/utils/string';
import http from 'src/services/httpService';

const DetalhamentoFinanceiroList = ({ projetoId, acaoId }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [valoresProjeto, setValoresProjeto] = useState([]);

  let filtroId = 93;
  let tag = 2032;
  
  const carregarValoresProjeto = async () => {
    http
      .post(`/DetalhamentoFinanceiro/ObterValoresProjeto`, {
        projetoId: projetoId,
      })
      .then((response) => {
        if (response.data && response.data.valores) {
          setValoresProjeto(response.data.valores);
        }
      });
  };

  const AtualizarValores = () => {
    if (projetoId) {
      carregarValoresProjeto(projetoId);
    }
  };


  return (
    <>
      {valoresProjeto &&
        valoresProjeto.length > 0 &&
        valoresProjeto
          .reduce((rows, item, index) => {
            const chunkIndex = Math.floor(index / 4);
            if (!rows[chunkIndex]) rows[chunkIndex] = [];
            rows[chunkIndex].push(item);
            return rows;
          }, [])
          .map((linha, idxLinha) => (
            <Row
              className="gx-1"
              key={idxLinha}
              style={{ marginBottom: '8px' }}
            >
              {linha.map((item, indexItem) => (
                <Col md={3} key={indexItem}>
                  <div
                    style={{
                      backgroundColor: '#F5F5F5',
                      padding: '8px 14px',
                      borderRadius: '8px',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <div style={{ fontSize: '12px', color: '#555' }}>
                      {item.estagio}
                    </div>

                    <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: '18px',
                        marginTop: '5px',
                      }}
                    >
                      {item.valorTotal}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ))}
      <Row>
        <Col md={12}>&nbsp;</Col>
      </Row>
      <Row>
        <Col md={12}>
          <List
            url="/DetalhamentoFinanceiro"
            editComponent={Edit}
            showExport={!acaoId}
            showSearch={!acaoId}
            searchSchema={SearchSchema}
            searchComponent={<Search />}
            filtroId={filtroId}
            sort="data"
            tag={tag}
            parameters={{
              projetoId: projetoId,
              acaoId: acaoId,
            }}
            refresh={AtualizarValores}
          >
            <ListColumn
              headerText={intl.formatMessage({ id: 'estagio' })}
              valueField="estagio"
              required
              default
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'valor' })}
              valueField="valor"
              required
              default
            />
            <ListColumn
              headerText={capitalizeFirstLetter(resources.acao)}
              valueField="acao"
              default
              visible={projetoId != null}
            />
            <ListColumn
              headerText={intl.formatMessage({ id: 'data' })}
              valueField="data"
              required
              default
            />
          </List>
        </Col>
      </Row>
    </>
  );
};

export default DetalhamentoFinanceiroList;
